import React, { Component } from "react";
import Analytics from "../../../helpers/analytics";
import Page from "../../index";
import Container from "../container";
import { ErrorsContainer } from "./styles";

class NotFound extends Component {
  render() {
    return (
      <Page id="PageNotFound" title="Page Not Found" contentType="website">
        <Container headerSticky={false}>
          <ErrorsContainer>
            <div class="img-overlay btn-responsive">
              <a href='https://www.jukinmedia.com/licensing'><button style={{ width: '250px', background: '#1EBEC8', fontSize: '14px' }} class="btn btn-md btn-success">LICENSING PLATFORM</button></a>
            </div>
          </ErrorsContainer>
        </Container>
      </Page>
    );
  }
}

export default NotFound;
